import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { ThemeContext } from "../../context/ThemeProvider";
import Create from "./Create";


export default function Createcouponcard() {

  // theme context


  let navigate = useNavigate();


  return (
    <>
      <Sidebar />
      <Nabvar />
      <Create />
    </>
  );
}
